import GuestProfileClient from './guest-client';

export async function generateStaticParams() {
  return [{ id: 'placeholder', guestId: 'placeholder' }];
}

export default function GuestProfilePage({ params }: { params: { id: string; guestId: string } }) {
  return <GuestProfileClient eventId={params.id} guestId={params.guestId} />;
}
